import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

import { QueryConfig } from "@/lib/react-query";
import { ApiContext } from "@/pages/hendren/api/context/ApiContextProvider";

export interface InstantInsights {
  tagline: string;
  type: "positive" | "negative";
  headline: string;
  content: string;
}
export interface InstantInsightsResult {
  insights: InstantInsights[];
}

export interface ChannelROIReportResult {
  data: {
    generatedQueries?: unknown;
    dataResults?: unknown;
    result?: InstantInsightsResult;
    error?: string;
  };
}

export interface ChannelROIParams {
  startDate?: string | null;
  endDate?: string | null;
  brand?: string;
  category?: string;
  product?: string;
  funnel?: string;
  channels?: string[];
  geos?: string[];
  comparisonStartDate?: string | null;
  comparisonEndDate?: string | null;
  shouldShiftSpend?: boolean;
}

export const useChannelROIInsights = ({
  startDate,
  endDate,
  brand,
  category,
  product,
  funnel,
  channels,
  geos,
  comparisonStartDate,
  comparisonEndDate,
  shouldShiftSpend,
  config,
}: ChannelROIParams & {
  config?: QueryConfig<any>;
}) => {
  const apiContext = useContext(ApiContext);
  if (!apiContext) {
    throw new Error("ApiContext must be used within ApiContextProvider");
  }
  const { apiClient } = apiContext;

  return useQuery({
    ...config,
    queryKey: [
      "channel-roi-report",
      startDate,
      endDate,
      brand,
      category,
      product,
      funnel,
      channels,
      geos,
      comparisonStartDate,
      comparisonEndDate,
      shouldShiftSpend,
    ],
    queryFn: async () => {
      return apiClient.get("/api/v1/channel-roi", {
        params: {
          startDate,
          endDate,
          brand,
          category,
          product,
          funnel,
          channels,
          geos,
          comparisonStartDate,
          comparisonEndDate,
          shouldShiftSpend,
        },
      });
    },
    select: ({ data }: ChannelROIReportResult) => {
      return {
        result: data.result,
        error: data.error,
      };
    },
  });
};
